/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LastPlacedOrderDeliveryDetailsQueryVariables = Types.Exact<{
  input: Types.OrdersInput;
}>;

export type LastPlacedOrderDeliveryDetailsQuery = {
  readonly __typename?: 'Query';
  readonly orders:
    | {
        readonly __typename: 'OrdersResponseSuccess';
        readonly orders: ReadonlyArray<{
          readonly __typename?: 'Order';
          readonly id: string;
          readonly deliveryOrderDetail: {
            readonly __typename?: 'DeliveryOrderDetail';
            readonly id: string;
            readonly address: {
              readonly __typename?: 'Address';
              readonly id: string;
              readonly googlePlaceId: string;
              readonly name: string | null;
            };
          } | null;
        }>;
      }
    | { readonly __typename?: 'ValidationError' };
};

export const lastPlacedOrderDeliveryDetailsQueryMock: ExecutionResult<LastPlacedOrderDeliveryDetailsQuery> =
  {
    data: {
      orders: {
        __typename: 'OrdersResponseSuccess',
        orders: [
          {
            id: '509e6ea9-fee4-42a9-9625-87ce71904308',
            deliveryOrderDetail: {
              id: 'da7a7163-ba7e-4da9-ae8a-185e3da00a9a',
              address: {
                id: '47534319-d080-460b-99aa-250f9c4016b1',
                googlePlaceId: 'Hello World',
                name: 'Hello World',
              },
            },
          },
          {
            id: 'bd634cb2-73b7-4f9f-98d0-30f1b1f2c49f',
            deliveryOrderDetail: {
              id: '5fd7994c-cdca-4b38-b748-5afbe88532ed',
              address: {
                id: 'e7a1daa9-33e0-4e09-9a7b-48f0bb560d01',
                googlePlaceId: 'Hello World',
                name: 'Hello World',
              },
            },
          },
          {
            id: '80d39ca0-c052-40a3-92a4-a6541b5bc5d0',
            deliveryOrderDetail: {
              id: '89f52e92-1d91-4bfd-bbab-d38fdf8eb150',
              address: {
                id: '587b384c-4829-49be-911f-9b1e39b6d74a',
                googlePlaceId: 'Hello World',
                name: 'Hello World',
              },
            },
          },
        ],
      },
    },
  };

export const LastPlacedOrderDeliveryDetailsDocument = gql`
  query LastPlacedOrderDeliveryDetails($input: OrdersInput!) {
    orders(input: $input) {
      ... on OrdersResponseSuccess {
        __typename
        orders {
          id
          deliveryOrderDetail {
            id
            address {
              id
              googlePlaceId
              name
            }
          }
        }
      }
    }
  }
`;

export function useLastPlacedOrderDeliveryDetailsQuery(
  options: Omit<
    Urql.UseQueryArgs<LastPlacedOrderDeliveryDetailsQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    LastPlacedOrderDeliveryDetailsQuery,
    LastPlacedOrderDeliveryDetailsQueryVariables
  >({ query: LastPlacedOrderDeliveryDetailsDocument, ...options });
}
